module.exports = __webpack_public_path__ + "img/chat-response.9794b702.png";